import Cookies from 'universal-cookie';
import { FALLBACK_LOCALE } from './constants';
class UserPreferredLocale {
    constructor(orConfig) {
        this.cookies = new Cookies();
        this.COOKIE_DOMAIN = orConfig.COOKIE_DOMAIN;
        this.COOKIE_NAME = `${orConfig.COOKIE_NAME_PREFIX}_locale`;
    }
    get() {
        const userPreferredLocale = this.cookies.get(this.COOKIE_NAME);
        return userPreferredLocale || FALLBACK_LOCALE;
    }
    set(locale) {
        this.cookies.set(this.COOKIE_NAME, locale, {
            path: '/',
            domain: this.COOKIE_DOMAIN,
        });
        return locale;
    }
}
export default UserPreferredLocale;
//# sourceMappingURL=UserPreferredLocale.js.map